export const capitalizeFirstletter = (str) =>
  str.charAt(0).toUpperCase() + str.slice(1);
